import { useEffect, useRef } from 'react';

const useElementObserver = (selector: string, callback: () => void, timeout = 5000) => {
  const timeoutIdRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const element = document.querySelector(selector);
      if (element) {
        callback();
        observer.disconnect();
        if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
      }
    });

    timeoutIdRef.current = setTimeout(() => {
      observer.disconnect();
    }, timeout);

    observer.observe(document.body, { childList: true });

    return () => {
      observer.disconnect();
      if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
    };
  }, []);
};

export default useElementObserver;
